import { BlockEmbed } from 'quill/blots/block';
export default class Img2TxtLoader extends BlockEmbed {
    static create(src) {
        const node = super.create(src);
        node.style.width = '100%';
        node.style.minHeight = '200px';
        node.style.position = 'relative';
        node.style.borderRadius = '12px';
        node.innerHTML = `
      <div class="loader-container">
        <span class="caption">Extracting text from image...</span>
        <div class="progress-loader" />
      </div>
    `;
        if (typeof src === 'string') {
            const image = document.createElement('img');
            image.setAttribute('src', src);
            image.style.width = '100%';
            image.style.height = 'auto';
            image.style.borderRadius = '12px';
            node.appendChild(image);
        }
        return node;
    }
    static value(domNode) {
        const { src, custom } = domNode.dataset;
        return { src, custom };
    }
    static blotName = 'img2TxtLoader';
    static className = 'img2Txt-loader';
    static tagName = 'div';
}
